import {JsonObject, JsonMember} from "typedjson-npm/js/typed-json";

let MedicineFrequencyType: {[key: string]: string} = {
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    SOS: "SOS"
};

let MedicineDurationUnit: {[key: string]: string} = {
    DAILY: "DAYS",
    WEEKLY: "WEEKS",
    MONTHLY: "MONTHS"
};


let MedicineInstructionCodes: {[key: string]: string} = {
    SOS: "As and when required",
    BEFORE_SLEEP: "Before sleep",
    BELOW_THE_TONGUE: "Below the tongue",
    BEFORE_FOOD: "Before food",
    AFTER_FOOD: "After food",
    EMPTY_STOMACH: "Empty stomach",
    CHEWABLE: "Chewable",
    PER_ORAL: "Per Oral",
    INTRADERMAL_INJECTION: "Intradermal Injection",
    INTRAMUSCULAR: "Intramuscular",
    INTRAVENOUS: "Intravenous",
    SUBCUTANEOUS: "Subcutaneous",
    NASAL_SPRAY: "Nasal Spray",
    PER_VAGINAL: "Per Vaginal",
    PER_RECTUM: "Per Rectum",
    LOCAL_APPLICATION: "Local Application",
    SUBLINGUAL: "Sublingual",
    TRANSDERMAL: "Transdermal"
};

let CallStatusCodeEnum: {[key: string]: string} = {
    COMPLETED_SUCCESSFULLY: "COMPLETED_SUCCESSFULLY"
};

let MedicineTypeInfo: {[key: string]: string} = {
    SYRUP: "Syrup",
    INJECTION: "Injection",
    CAPSULE: "Capsule",
    TABLET: "Tablet",
    CREAM: "Cream",
    DROP: "Drop",
    SPRAY: "Spray"
};

export {
    MedicineInstructionCodes,
    MedicineFrequencyType,
    CallStatusCodeEnum,
    MedicineTypeInfo,
    MedicineDurationUnit
}